import {MetricEntry, MetricEntryBehavior} from 'common/query-builder/query-entry-section/types';
import {MetricType, PRIMITIVE_MATH_TYPES, TopLevelMetricType} from 'common/types/reports/bookmark';
import {RestrictEntitySaving} from 'common/report/constants';
import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {promptInProductUpsellModal} from 'common/widgets/in-product-upsell-modal/prompt';
import {ModalTrigger} from 'common/widgets/in-product-upsell-modal/util';

export function getNewSimpleMetricEntry({isExpanded}: {isExpanded: boolean}): MetricEntry {
  return {
    type: TopLevelMetricType.NewMetricEntry,
    behavior: {
      type: MetricType.Simple,
      name: null,
      behaviors: [getEmptyEventMetricEntryBehavior()],
    },
    measurement: {
      aggregationOperator: PRIMITIVE_MATH_TYPES.UNIQUE,
    },
    isExpanded,
  };
}

/**
 * This is an empty event selection behavior that can be used in funnel, simple
 * or retention behaviors.
 */
export function getEmptyEventMetricEntryBehavior(): MetricEntryBehavior {
  return {
    type: MetricType.Event,
    name: null,
    filters: [],
  };
}

export function checkUpsellForMetric(currentProject: CurrentProject | undefined): {
  shouldUpsell: boolean;
  upsellAction: () => void;
} {
  const canSave = Boolean(currentProject?.canSaveEntity(RestrictEntitySaving.Formulas));
  return {
    shouldUpsell: !canSave,
    upsellAction: () => promptInProductUpsellModal(ModalTrigger.FORMULA),
  };
}

export function checkUpsellForMetricBehavior(currentProject: CurrentProject | undefined): {
  shouldUpsell: boolean;
  upsellAction: () => void;
} {
  const canSave = Boolean(currentProject?.canSaveEntity(RestrictEntitySaving.BehaviorMetrics));
  return {
    shouldUpsell: !canSave,
    upsellAction: () => promptInProductUpsellModal(ModalTrigger.METRICS),
  };
}
